<utc-modal modal class="hvac-manage-groups-utc-modal" [visible]="isModalVisible" (closeAction)="handleCloseModal()"
    size="medium" [showHeader]="true" theme="rounded">

    <hvac-modal-header>
        <div class="hvac-manage-groups-modal-header">
            <h2>
                {{'ACCOUNT_ADMIN.MANAGE_GROUPS.HEADING' | translate }}
            </h2>
        </div>
    </hvac-modal-header>

    <div class="hvac-manage-groups-modal">
        <hvac-toast [name]="toastId"></hvac-toast>
        <utc-loading-spinner *ngIf="isLoading" [spinnerSize]="'small'"></utc-loading-spinner>

        <div class="hvac-manage-groups-modal-tabs">
            <hvac-tab-bar variant="secondary">
                <button buttonType="button" (click)="handleTabClick('createGroup')"
                    [ngClass]="{ 'hvac-active': selectedTab === 'createGroup' }">
                    {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.TAB_HEADING' | translate }}
                </button>
                <button buttonType="button" (click)="handleTabClick('bulkMapping')"
                    [ngClass]="{ 'hvac-active': selectedTab === 'bulkMapping' }">
                    {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.TAB_HEADING' | translate }}
                </button>
                <button buttonType="button" (click)="handleTabClick('deleteGroup')"
                    [ngClass]="{ 'hvac-active': selectedTab === 'deleteGroup' }">
                    {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.TAB_HEADING' | translate }}
                </button>
            </hvac-tab-bar>
        </div>

        <div class="hvac-manage-groups-tab-content" *ngIf="selectedTab === 'createGroup'">
            <h4 class="hvac-h4">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.CREATE_A_NEW_GROUP' | translate }}</h4>

            <form [formGroup]="createGroupForm">
                <div class="hvac-row hvac-manage-groups-row">
                    <div class="hvac-col-lg-3 hvac-label hvac-required">
                        {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.GROUP_NAME' | translate }}
                    </div>
                    <utc-input class="hvac-col-xs-12 hvac-col-lg-6"
                        [placeholder]="'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.GROUP_NAME' | translate" [hideLabel]="false"
                        shadow="light" size="small" [inputControl]="createGroupForm.controls.groupName" type="text">
                    </utc-input>
                </div>

                <div class="hvac-row hvac-manage-groups-row">
                    <div class="hvac-col-lg-3 hvac-label">
                        {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.COMMENTS' | translate }}
                    </div>
                    <utc-input class="hvac-col-xs-12 hvac-col-lg-9"
                        [placeholder]="'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.COMMENTS' | translate" [hideLabel]="false"
                        shadow="light" size="small" [inputControl]="createGroupForm.controls.comments" type="text">
                    </utc-input>
                </div>

                <div class="hvac-manage-groups-footer">
                    <button class="hvac-footer-buttons" [hvacButton]="'default'" (click)="handleCloseModal()">
                        <span>{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.CANCEL' | translate }}</span>
                    </button>
                    <button [hvacButton]="'primary'" (click)="onCreateGroupSubmit(createGroupForm)"
                        [disabled]="!createGroupForm.valid">
                        <span>{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.CREATE_GROUP_TAB.CREATE' | translate }}</span>
                    </button>
                </div>
            </form>
        </div>

        <div class="hvac-manage-groups-tab-content" *ngIf="selectedTab === 'bulkMapping'">
            <h4 class="hvac-h4">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.ASSIGN_COMPANIES_TO_A_GROUP' | translate }}</h4>
            <form [formGroup]="bulkMappingForm">

                <h4 class="hvac-h4">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.SELECT_A_GROUP_HEADER_1' | translate }}</h4>

                <div class="hvac-row hvac-manage-groups-row">
                    <utc-select class="hvac-existing-groups-select hvac-col-xs-12 hvac-col-lg-6"
                        [shadow]="'light'"
                        [size]="'small'"
                        [options]="existingGroups || []"
                        [group]="bulkMappingForm"
                        [control]="'selectedGroup'"
                        [defaultOption]="'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.SELECT_GROUP' | translate">
                    </utc-select>
                </div>

                <h4 class="hvac-h4">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.SELECT_COMPANIES_HEADER_2' | translate }}</h4>

                <div class="hvac-row hvac-autocomplete-modal-container">
                    <div class="hvac-autocomplete-container hvac-col-xs-12 hvac-col-lg-5 hvac-col-md-6">
                        <label class="hvac-label">{{ "ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.COMPANY_NAME" | translate }}</label>
                        <hvac-autocomplete [inputControl]="$any(bulkMappingForm.controls.companyName)"
                            [data]="(companyLookUpData$ | async) || []"
                            class="hvac-col-xs"
                            (onSelect)="onCompanyLookUp($event)"
                            (onLoadMore)="companyLookupWithPagination()"
                            [disabledInput]="companyNameInputDisabled"
                            [placeholder]="'ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.COMPANY_NAME' | translate"
                            [event]="(autoComplete$ | async) || {loading: false}">
                        </hvac-autocomplete>
                        <div class="hvac-autocomplete-no-result"
                            *ngIf="bulkMappingForm.controls.companyName.value && noResultsFound && !((autoComplete$ | async)?.loading)">
                            {{ 'ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.NO_RESULTS_FOUND' | translate }}
                        </div>
                    </div>

                    <div class="hvac-or-text">{{ "ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.OR" | translate }}</div>

                    <div class="hvac-autocomplete-container hvac-col-xs-12 hvac-col-lg-5 hvac-col-md-6">
                        <label class="hvac-label">{{ "ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.HVAC_ID" | translate }}</label>
                        <hvac-autocomplete [inputControl]="$any(bulkMappingForm.controls.hvacpId)"
                            [data]="(companyLookUpDataHvacpId$ | async) || []"
                            class="hvac-col-xs"
                            (onSelect)="onCompanyLookUp($event)"
                            (onLoadMore)="companyHvacpIdLookupWithPagination()"
                            [disabledInput]="hvacpIdInputDisabled"
                            [placeholder]="'ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.HVAC_ID' | translate"
                            [event]="(autoCompleteHvacId$ | async) || {loading: false}">
                        </hvac-autocomplete>
                        <div class="hvac-autocomplete-no-result"
                            *ngIf="bulkMappingForm.controls.hvacpId.value && noResultsFound && !((autoCompleteHvacId$ | async)?.loading)">
                            {{ 'ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.NO_RESULTS_FOUND' | translate }}
                        </div>
                    </div>
                </div>

                <div class="hvac-selected-companies" *ngIf="selectedCompanies.length">
                    <label class="hvac-label">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.SELECTED_COMPANIES' | translate }}</label>
                    <hvac-chip *ngFor="let company of selectedCompanies"
                        [text]="company.companyId"
                        [chipId]="company.companyId"
                        (onChipClose)="removeSelectedCompany($event)">
                    </hvac-chip>
                </div>

                <div class="hvac-manage-groups-footer">
                    <button [hvacButton]="'primary'" (click)="onBulkMappingSubmit()" [disabled]="!canSubmitBulkMapping || isLoading">
                        <span>{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.BULK_COMPANY_TO_GROUP_MAPPING.BULK_UPDATE' | translate }}</span>
                    </button>
                </div>
            </form>
        </div>

        <div class="hvac-manage-groups-tab-content" *ngIf="selectedTab === 'deleteGroup'">
            <h4 class="hvac-h4">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.DELETE_A_GROUP' | translate }}</h4>

            <div class="hvac-row hvac-manage-groups-row">
                <div class="hvac-col-lg-3 hvac-label">
                    {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.GROUPS' | translate }}
                </div>
                <utc-select class="hvac-existing-groups-select hvac-col-xs-12 hvac-col-lg-6" [shadow]="'light'"
                    [size]="'small'" [options]="existingGroups || []" [group]="existingGroupsForm"
                    [control]="'selectedGroup'"
                    [defaultOption]="'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.GROUPS' | translate">
                </utc-select>
            </div>
            <div class="hvac-selected-group-details" *ngIf="selectedGroupToDelete">
                <h5 class="hvac-h5">{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.SELECTED_GROUP_DETAILS' | translate }}</h5>
                <div class="hvac-selected-group-detail-row">
                    <div class="hvac-label">
                        {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.GROUP_NAME' | translate }}
                    </div>
                    <div class="hvac-selected-group-detail-value">
                        {{ selectedGroupToDelete.name }}
                    </div>
                </div>
                <div class="hvac-selected-group-detail-row">
                    <div class="hvac-label">
                        {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.GROUP_ID' | translate }}
                    </div>
                    <div class="hvac-selected-group-detail-value">
                        {{ selectedGroupToDelete.value }}
                    </div>
                </div>
                <div class="hvac-selected-group-detail-row">
                    <div class="hvac-label">
                        {{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.COMMENTS' | translate }}
                    </div>
                    <div class="hvac-selected-group-detail-value">
                        {{ selectedGroupToDelete.comments || '-' }}
                    </div>
                </div>
            </div>
            <div class="delete-groups-footer">
                <button [hvacButton]="'primary'" (click)="deleteGroup()" [disabled]="!selectedGroupToDelete || isLoading">
                    <span>{{ 'ACCOUNT_ADMIN.MANAGE_GROUPS.TABS.DELETE_GROUP.DELETE' | translate }}</span>
                </button>
            </div>

        </div>
    </div>
</utc-modal>
